module.exports = __webpack_public_path__ + "inputs/img/UniversityLogo.ff7343b6.png";